import { useNavigate } from "react-router-dom"

export default function Icons({ navbarIsActive, setNavbarIsActive }) {
    const navigate = useNavigate();
    const isLogin = localStorage.getItem('token');

    return (
        <div className="icons">
            {!isLogin && <img src="/images/partials/auth-icon.svg" alt="auth" className="auth-icon" onClick={() => navigate('/user/login')} />}
            
            <img
                alt="menubar"
                className="menubar-icon"
                src={navbarIsActive ? "/images/partials/xmark.svg" : "/images/partials/menubar.svg"}
                onClick={() => setNavbarIsActive(prev => !prev)}
            />
        </div>
    )
}
